// Este archivo es generado automáticamente por scripts/sync-version.js
// NO EDITAR MANUALMENTE - La versión se lee de package.json

export const APP_VERSION = '2.3.2';
